import { Injectable } from "@angular/core";
import { from, BehaviorSubject, Observable } from "rxjs";
import { i18n_de } from "../../i18n/i18n_de";
import { i18n_en } from "i18n/i18n_en";

@Injectable({
  providedIn: "root",
})
export class TranslationService {
  private current_language_sub: BehaviorSubject<string> = new BehaviorSubject(
    "de"
  );
  current_lang_observable: Observable<string> = this.current_language_sub;

  private current_dictionary_sub: BehaviorSubject<{}> = new BehaviorSubject(
    this.getDictionary
  );
  current_dictionary_observable: Observable<{}> = this.current_dictionary_sub;

  constructor() {}

  getDictionary() {
    switch (this.current_language_sub.value) {
      case "de":
        return i18n_de;
      case "en":
        return i18n_en;
    }
  }
  getLanguage() {
    return this.current_language_sub.value;
  }

  setLanguage(lang: string) {
    if (lang === "en" || lang === "de") {
      this.current_language_sub.next(lang);
      this.current_dictionary_sub.next(this.getDictionary());
    }
  }
}
